import { useState, useEffect } from 'react';

/**
 * Hook pre získanie informácií o sieťovom pripojení pomocou Network Information API
 * Pomáha rozhodnúť, či načítať vysokokvalitné médiá alebo použiť optimalizované verzie
 */
export const useNetworkInfo = () => {
  const [networkInfo, setNetworkInfo] = useState({
    effectiveType: '4g', // fallback na 4g
    downlink: 10, // fallback na 10 Mbps
    saveData: false,
    rtt: 50, // round-trip time
    isSlowConnection: false,
    isSupported: false
  });

  useEffect(() => {
    // Kontrola podpory Network Information API
    if ('connection' in navigator || 'mozConnection' in navigator || 'webkitConnection' in navigator) {
      const connection = navigator.connection || 
                        navigator.mozConnection || 
                        navigator.webkitConnection;

      const updateNetworkInfo = () => {
        const effectiveType = connection.effectiveType || '4g';
        const downlink = connection.downlink || 10;
        const saveData = connection.saveData || false;
        const rtt = connection.rtt || 50;

        // Určenie, či je pripojenie pomalé
        // Považujeme za pomalé ak: effectiveType je 2g alebo 3g, alebo downlink < 1.5 Mbps
        const isSlowConnection = effectiveType === '2g' || 
                                 effectiveType === 'slow-2g' ||
                                 (effectiveType === '3g' && downlink < 1.5) ||
                                 downlink < 1.5 ||
                                 saveData;

        setNetworkInfo({
          effectiveType,
          downlink,
          saveData,
          rtt,
          isSlowConnection,
          isSupported: true
        });
      };

      // Počiatočné nastavenie
      updateNetworkInfo();

      // Sledovanie zmien pripojenia
      if (connection) {
        connection.addEventListener('change', updateNetworkInfo);
      }

      // Cleanup
      return () => {
        if (connection) {
          connection.removeEventListener('change', updateNetworkInfo);
        }
      };
    } else {
      // Ak API nie je podporované, predpokladáme dobré pripojenie
      setNetworkInfo(prev => ({
        ...prev,
        isSupported: false
      }));
    }
  }, []);

  return networkInfo;
};
